import { createSlice } from "@reduxjs/toolkit";
import { app_reset } from "../App/reducer";

export const initialTrackingState = () => {
    return {
        tracking: {},
    };
};

const trackingSlice = createSlice({
    name: "tracking",
    initialState: initialTrackingState(),
    reducers: {
        update_tracking: (state, action) => {
            return { ...state, tracking: action.payload };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(app_reset, () => {
            return initialTrackingState();
        });
    },
});

export const { update_tracking } = trackingSlice.actions;

export default trackingSlice.reducer;
